import { styled, css } from "styled-components";

import { StyledLinkProps, styledLink } from "components/Link/Link.styled";
import close28 from "icons/close28.svg";
import closeSmall28 from "icons/closeSmall28.svg";
import {
    styleBodyM,
    styleHeadingS,
    styleMapCluster,
} from "style/components/Typography";
import { MQ } from "style/mediaQueries";

export const Container = styled.div<ContainerProps>`
    .clusterLabel {
        ${styleMapCluster};
    }

    .gm-style-iw {
        border-radius: 0.25rem;
        padding: 0;
        transition: width ease-in-out 0.2s;
        ${(props) =>
            props.mapWidth &&
            props.mapWidth > 0 &&
            css`
                width: calc((${props.mapWidth}px / 4) * 3 - 1.75rem);

                ${MQ.FROM_M} {
                    width: calc((${props.mapWidth}px / 12) * 5 - 2.1875rem);
                }

                ${MQ.FROM_L} {
                    width: calc((${props.mapWidth}px / 7) * 4 - 2.1875rem);
                }

                ${MQ.FROM_XL} {
                    width: calc((${props.mapWidth}px / 7) * 3 - 3.5rem);
                }
            `};

        button.gm-ui-hover-effect {
            height: 1.75rem !important;
            opacity: 1;
            right: 0.875rem !important;
            top: 0.875rem !important;
            width: 1.75rem !important;

            > span {
                mask-image: url(${closeSmall28}) !important;
                background-color: var(--color-blue);
                height: 1.75rem !important;
                margin: 0 !important;
                width: 1.75rem !important;

                ${MQ.FROM_M} {
                    mask-image: url(${close28}) !important;
                }
            }
        }

        &-d {
            overflow: auto !important;
        }

        &-tc {
            filter: none;
            height: 0.5rem;
            width: 0.875rem;

            &::after {
                background-color: var(--color-cyan-l80);
                height: 0.5rem;
                width: 0.875rem;
            }
        }
    }
`;

export const InfoWindow = styled.div`
    align-items: flex-start;
    background-color: var(--color-cyan-l80);
    border-radius: 0.25rem;
    color: black;
    display: flex;
    flex-direction: column;
    font-feature-settings: "salt" on;
    padding: 0.875rem 2.1875rem 0.875rem 0.875rem;

    ${MQ.FROM_M} {
        padding: 1.3125rem 3.5rem 1.3125rem 1.3125rem;
    }

    ${MQ.FROM_L} {
        padding: 1.75rem 3.5rem 1.75rem 1.75rem;
    }
`;

export const InfoWindowHeading = styled.a<StyledLinkProps>`
    ${styleHeadingS};
    ${styledLink};
    transform: none;
`;

export const InfoWindowText = styled.div`
    ${styleBodyM};
`;

export const InfoWindowFindUs = styled.a<StyledLinkProps>`
    ${styleBodyM};
    ${styledLink};
    margin-top: 0.875rem;

    img {
        vertical-align: middle;
    }
`;
interface ContainerProps {
    mapWidth?: number;
}
